export default "__VITE_ASSET__Ctl2scMV__"